import React from 'react';
import { Typography, makeStyles } from '@rbx/ui';
import { getEngineRevampHeadingStyle } from '@modules/ui/shared/utils/styles';

const useReferenceSummarySectionTitleStyles = makeStyles()(() => ({
  titleContainer: {
    marginBottom: '12px',
  },
  titleText: {
    ...getEngineRevampHeadingStyle(),
  },
}));

interface ReferenceSummarySectionTitleProps {
  title: string;
}

export default function ReferenceSummarySectionTitle({ title }: ReferenceSummarySectionTitleProps) {
  const {
    classes: { titleContainer, titleText },
  } = useReferenceSummarySectionTitleStyles();

  return (
    <div className={titleContainer}>
      <Typography variant='subtitle2' className={titleText}>
        {title}
      </Typography>
    </div>
  );
}
